import React, { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { MyContextSupply } from "../../Context";
import "react-toastify/dist/ReactToastify.css";
import ShortDisplayReview from "../ReviewRating/ShortDisplayReview";
import { AiOutlineHome, AiFillFire } from "react-icons/ai";
import { FaCartPlus, FaShoppingBag } from "react-icons/fa";
import { VscTriangleRight } from "react-icons/vsc";
import axios from "axios";
import "./festival.css";

const FestivalLaunches = () => {
  const {
    handleAddProduct,
    toggleRunPath,
    setIsProductAddPopUpOpen,
    setSingleProductPathId,
  } = MyContextSupply();
  const navigate = useNavigate();
  const [festivalProduct, setFestivalProduct] = useState("");
  const [loading, setLoading] = useState(false);

  const getinddata = async () => {
    setLoading(true);
    await axios
      .get(`https://stechbackend-9r4c.onrender.com/festivallaunces`)
      .then((res) => {
        if (res) {
          const sortData = res.data.sort().reverse();
          setFestivalProduct(sortData);
          setLoading(false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  useEffect(() => {
    const tim = setTimeout(getinddata, 1.5);
    return () => {
      clearTimeout(tim);
    };
  }, []);

  // console.log(festivalProduct);
  return (
    <div className="cart_section festival_cart_section">
      {!loading ? (
        <>
          {festivalProduct.length !== 0 &&
            festivalProduct.map((product) => {
              const {
                _id: id,
                category,
                description,
                price: { mrp, cost },
                review,
                tagline,
                title,
                url,
              } = product !== undefined && product;
              let discount = ((mrp - cost) / mrp) * 100;
              if (discount % 1 === 0) {
                discount = parseInt(discount);
              } else {
                discount = discount.toFixed(2);
              }
              return (
                <div key={id}>
                  <div className="cart-full-footer-style  festival-header-height">
                    <h1 style={{ textAlign: "center" }}>{title?.shortTitle}</h1>
                  </div>
                  <div className="cart_container  festival_container">
                    <div className="left_cart">
                      <img src={url} alt="" />
                      <div className="cart_btn">
                        <button
                          className="cart_btn1 festival_btn1"
                          onClick={() => {
                            handleAddProduct(product);
                            setIsProductAddPopUpOpen(true);
                          }}
                        >
                          <FaCartPlus className="icon-festival-ad" /> Add to
                          Cart
                        </button>
                        <button
                          onClick={() => {
                            handleAddProduct(product);
                            navigate("/buynow");
                            toggleRunPath();
                          }}
                          className="cart_btn2 festival_btn1"
                        >
                          <FaShoppingBag className="icon-festival-ad" /> Buy Now
                        </button>
                      </div>
                    </div>
                    <div className="right_cart">
                      <div className="right_cart_inside festival_inside">
                        <h3>{title?.longTitle}</h3>
                        <div style={{ display: "flex" }}>
                          <p style={{ marginTop: "6px" }}>Ratings:</p>
                          <ShortDisplayReview
                            review={review}
                            fontSizeCustom={20}
                          />
                        </div>
                        <Divider />
                        <p className="price-festival">
                          Price:
                          <span style={{ color: "red" }}> ${cost}</span>
                        </p>
                        <p className="description">
                          About the Product:
                          <span
                            style={{
                              color: "#504f4f",
                              fontSize: "16px",
                              fontWeight: 500,
                              letterSpacing: "0.2px",
                            }}
                            className="desc-span-festival"
                          >
                            {description}
                          </span>
                        </p>
                        <div className="review-btns-add-show festival_btns_des">
                          <button
                            onClick={() => {
                              toggleRunPath();
                              setSingleProductPathId(id);
                              navigate(`/getproductsone/${id}`);
                            }}
                            className="write-a-review-btn"
                          >
                            View Details{" "}
                            <VscTriangleRight className="review-write-icon" />
                          </button>
                          <button
                            onClick={() => navigate("/")}
                            className="write-a-review-btn"
                          >
                            <AiOutlineHome className="review-write-icon" /> Back
                            to Home
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4 className="h-festival-discount">
                    In this festival buy {title?.shortTitle} and get{" "}
                    <span>
                      <AiFillFire style={{ paddingTop: "2px" }} />
                      {discount}%
                    </span>{" "}
                    discount
                  </h4>
                </div>
              );
            })}
        </>
      ) : (
        <div className="circle">
          <CircularProgress />
          <h2>Loading Data</h2>
        </div>
      )}
    </div>
  );
};

export default FestivalLaunches;
